import React, {
  createContext,
  useState,
  useRef,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import * as apiInit from "../utils/ApiInit.ts";
import Icon from "../components/widgets/Icon";

interface InitDataForTablesContextInterface {
  itemsAdquisicion: any[];
  itemsAdquisicionFull: any[];
  centrosCosto: any[];
  centrosCostoFull: any[];
  proveedores: any[];
  tipoSolicitudes: any[];
  meses: any[];
  estadosOperacionales: any[];
  tiposMoneda: any[];
  isTutorialActive: boolean;
  setIsTutorialActive: Dispatch<SetStateAction<any>>;
  estadosSolicitud: any[];
  tiposItemsAdquisicion: any[];
  estadosOrdenes: any[];
  proveedoresFull: any[];
  aprobadores: any[];
  aprobadoresFull: any[];
}

const defaultState: InitDataForTablesContextInterface = {
  itemsAdquisicion: [],
  itemsAdquisicionFull: [],
  centrosCosto: [],
  centrosCostoFull: [],
  proveedores: [],
  tipoSolicitudes: [],
  meses: [],
  estadosOperacionales: [],
  tiposMoneda: [],
  isTutorialActive: false,
  setIsTutorialActive: () => {},
  estadosSolicitud: [],
  tiposItemsAdquisicion: [],
  estadosOrdenes: [],
  proveedoresFull: [],
  aprobadores: [],
  aprobadoresFull: [],
};

const InitDataForTablesContext = createContext(defaultState);

/*export const InitDataContext = createContext({
  initData: (value: React.State),
  setInitData: (value: React.SetStateAction<{}>) => {},
  menus: {},
  setMenus: (value: React.SetStateAction<{}>) => {},
  userId: userId,
  idEmpresa: idEmpresa,
  isTutorialActive: false,
  setIsTutorialActive: (value: React.SetStateAction<boolean>) => {}
});*/

/*function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function getToken() {
  let query = useQuery();
  console.log('TOKEN: ' + query.get("token"));

  if (query.get('token') != null) {
    localStorage.setItem('token', query.get('token') || '');
  }
  return localStorage.getItem('token');
}

function getUserName() {
  let query = useQuery();
  console.log('USER NAME: ' + query.get("user"));

  if (query.get('user') != null) {
    localStorage.setItem('userName', query.get('user') || '');
  }
  return localStorage.getItem('userName');
}


function getIdEmpresa() {
  let query = useQuery();
  console.log('EMPRESA ID: ' + query.get("idEmpresa"));

  if (query.get('idEmpresa') != null) {
    localStorage.setItem('idEmpresa', query.get('idEmpresa') || '');
  }
  return localStorage.getItem('idEmpresa');
}

function getUserId() {
  let query = useQuery();
  console.log('USER ID: ' + query.get("userId"));

  if (query.get('userId') != null) {
    localStorage.setItem('userId', query.get('userId') || '');
  }
  return localStorage.getItem('userId');
}
  */

//SE PUEDEN CREAR TANTOS DataProvider NECESITEMOS
//export const InitDataProvider = ({ children }: { children: any }) => {

// VERSION DEL CACHE DE CATALOGOS EN LOCALSTORAGE.
// INCREMENTAR CUANDO CAMBIEN DATOS MAESTROS EN BD (TIPOS, ESTADOS, ETC.)
// PARA FORZAR QUE TODOS LOS NAVEGADORES LOS VUELVAN A DESCARGAR.
const CATALOG_CACHE_VERSION = "2";
const CATALOG_CACHE_KEYS = [
  "tipoSolicitudes",
  "meses",
  "estadosOperacionales",
  "estadosOperacionales_timestamp",
  "tiposMoneda",
  "estadosSolicitud",
  "tiposItemsAdquisicion",
  "estadosOrdenes",
];

const invalidateCatalogCacheIfOutdated = () => {
  if (localStorage.getItem("catalogCacheVersion") !== CATALOG_CACHE_VERSION) {
    CATALOG_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
    localStorage.setItem("catalogCacheVersion", CATALOG_CACHE_VERSION);
  }
};

type InitDataForTablesProviderProps = {
  children: React.ReactNode;
};

const InitDataForTablesProvider = ({
  children,
}: InitDataForTablesProviderProps) => {
  // ... (tus useState se mantienen igual)
  const componentIsMounted = useRef(true);
  const [itemsAdquisicion, setItemsAdquisicion] = useState<any[]>([]);
  const [itemsAdquisicionFull, setItemsAdquisicionFull] = useState<any[]>([]);
  const [centrosCostoFull, setCentrosCostoFull] = useState([]);
  const [centrosCosto, setCentrosCosto] = useState<any[]>([]);
  const [proveedores, setProveedores] = useState([]);
  const [tipoSolicitudes, setTipoSolicitudes] = useState([]);
  const [meses, setMeses] = useState([]);
  const [estadosOperacionales, setEstadosOperaciones] = useState([]);
  const [tiposMoneda, setTiposMoneda] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isTutorialActive, setIsTutorialActive] = useState(false);
  const [estadosSolicitud, setEstadosSolicitud] = useState([]);
  const [tiposItemsAdquisicion, setTiposItemsAdquisicion] = useState<any[]>([]);
  const [estadosOrdenes, setEstadosOrdenes] = useState<any[]>([]);
  const [proveedoresFull, setProveedoresFull] = useState([]);
  const [aprobadores, setAprobadores] = useState([]);
  const [aprobadoresFull, setAprobadoresFull] = useState([]);

  useEffect(() => {
    const isTutorialActiveVar = localStorage.getItem("isTutorialActive");
    if (isTutorialActiveVar === "true") {
      setIsTutorialActive(true);
    } else {
      setIsTutorialActive(false);
    }
  }, []);

  // --- FUNCIONES DE CARGA ---
  // Nota: No he cambiado la lógica interna de tus funciones,
  // solo asegúrate de que todas sean async.

  const fetchInitDataItemsForTables = async () => {
    try {
      const response =
        await apiInit.GET_INIT_DATA_ITEMS_ADQ.getInitDataItemsAdq();
      if (response) {
        setItemsAdquisicionFull(response);
        const arr = JSON.parse(JSON.stringify(response));
        arr.forEach((obj: any) => {
          delete obj.nombre;
          delete obj.activo;
          renameKey(obj, "nombre_compuesto", "nombre");
        });
        setItemsAdquisicion(arr);
      }
    } catch (e) {
      console.error("Error items", e);
    }
  };

  const fetchInitDataCentrosForTables = async () => {
    try {
      const response =
        await apiInit.GET_INIT_DATA_CENTROS_COSTO.getInitDataCentrosCosto();
      if (response !== null) {
        setCentrosCostoFull(response);
        const arr = JSON.parse(JSON.stringify(response));
        arr.forEach((obj: any) => {
          delete obj.id_area;
          delete obj.codigo;
          delete obj.old_id;
          delete obj.activo;
          delete obj.dt_cre;
          delete obj.dt_mod;
        });
        setCentrosCosto(arr);
        localStorage.setItem("centrosCosto", JSON.stringify(arr));
      }
    } catch (e) {
      console.error("Error centros costo", e);
    }
  };

  const fetchInitDataProveedoresForTables = async () => {
    try {
      const response =
        await apiInit.GET_INIT_DATA_PROVEEDORES.getInitDataProveedores();
      if (response !== null) {
        setProveedoresFull(response);
        const arr = JSON.parse(JSON.stringify(response));
        arr.forEach((obj: any) => {
          delete obj.nombre;
          renameKey(obj, "nombre_compuesto", "nombre");
        });
        setProveedores(arr);
      }
    } catch (e) {
      console.error("Error proveedores", e);
    }
  };

  // Para las funciones que usan LocalStorage, la lógica ya estaba bien dentro de la función:
  // "Si no existe en storage -> API -> SetState. Si existe -> SetState".
  // Por lo tanto, solo necesitamos llamarlas y ESPERARLAS (await).

  const fetchInitDataTiposSolicitud = async () => {
    if (localStorage.getItem("tipoSolicitudes") === null) {
      const response =
        await apiInit.GET_INIT_DATA_TIPOS_SOLICITUD.getTiposSolicitud();
      if (response !== null) {
        const arr = JSON.parse(JSON.stringify(response));
        arr.forEach((obj: any) => {
          delete obj.nombre;
          renameKey(obj, "nombre_compuesto", "nombre");
        });
        // OJO: Aquí tenías setItemsAdquisicion(arr) por error en tu código original?
        // Debería ser setTipoSolicitudes o una variable temporal.
        // Asumo que querías guardar response limpio:
        localStorage.setItem("tipoSolicitudes", JSON.stringify(response));
        setTipoSolicitudes(response);
      }
    } else {
      const tipoSolicitudesStorage = JSON.parse(
        localStorage.getItem("tipoSolicitudes") || "[]",
      );
      setTipoSolicitudes(tipoSolicitudesStorage);
    }
  };

  const fetchInitDataMeses = async () => {
    if (localStorage.getItem("meses") === null) {
      const response = await apiInit.GET_INIT_DATA_MESES.getMeses();
      if (response !== null) {
        localStorage.setItem("meses", JSON.stringify(response));
        setMeses(response);
      }
    } else {
      const mesesStorage = JSON.parse(localStorage.getItem("meses") || "[]");
      setMeses(mesesStorage);
    }
  };

  /*const fetchInitDataEstadosOperacionales = async () => {
    if (localStorage.getItem("estadosOperacionales") === null) {
      const response =
        await apiInit.GET_INIT_DATA_ESTADOS_OP.getEstadosOperacionales();
      if (response !== null) {
        localStorage.setItem("estadosOperacionales", JSON.stringify(response));
        setEstadosOperaciones(response);
      }
    } else {
      const storage = JSON.parse(
        localStorage.getItem("estadosOperacionales") || "[]",
      );
      setEstadosOperaciones(storage);
    }
  };*/

  const fetchInitDataEstadosOperacionales = async () => {
    const cachedData = localStorage.getItem("estadosOperacionales");
    const cacheTime = localStorage.getItem("estadosOperacionales_timestamp");

    const ahora = new Date().getTime();
    const UN_DIA = 24 * 60 * 60 * 1000; // 24 horas en milisegundos

    // Si no hay datos O si el caché expiró
    if (!cachedData || !cacheTime || ahora - Number(cacheTime) > UN_DIA) {
      const response =
        await apiInit.GET_INIT_DATA_ESTADOS_OP.getEstadosOperacionales();

      if (response) {
        localStorage.setItem("estadosOperacionales", JSON.stringify(response));
        localStorage.setItem(
          "estadosOperacionales_timestamp",
          ahora.toString(),
        );
        setEstadosOperaciones(response);
      }
    } else {
      setEstadosOperaciones(JSON.parse(cachedData));
    }
  };

  const fetchInitDataTiposMoneda = async () => {
    if (localStorage.getItem("tiposMoneda") === null) {
      const response =
        await apiInit.GET_INIT_DATA_TIPOS_MONEDA.getTiposMoneda();
      if (response !== null) {
        localStorage.setItem("tiposMoneda", JSON.stringify(response));
        setTiposMoneda(response);
      }
    } else {
      const storage = JSON.parse(localStorage.getItem("tiposMoneda") || "[]");
      setTiposMoneda(storage);
    }
  };

  const fetchInitDataEstadosSolicitud = async () => {
    if (localStorage.getItem("estadosSolicitud") === null) {
      const response =
        await apiInit.GET_INIT_DATA_ESTADOS_SOLICITUD.getEstadosSolicitud();
      if (response !== null) {
        localStorage.setItem("estadosSolicitud", JSON.stringify(response));
        setEstadosSolicitud(response);
      }
    } else {
      const storage = JSON.parse(
        localStorage.getItem("estadosSolicitud") || "[]",
      );
      setEstadosSolicitud(storage);
    }
  };

  const fetchInitDataTiposItemsAdq = async () => {
    if (localStorage.getItem("tiposItemsAdquisicion") === null) {
      const response =
        await apiInit.GET_INIT_DATA_TIPOS_ITEMS_ADQ.getTiposItemsAdq();
      if (response !== null) {
        localStorage.setItem("tiposItemsAdquisicion", JSON.stringify(response));
        setTiposItemsAdquisicion(response);
      }
    } else {
      const storage = JSON.parse(
        localStorage.getItem("tiposItemsAdquisicion") || "[]",
      );
      setTiposItemsAdquisicion(storage);
    }
  };

  const fetchInitDataEstadosOrdenes = async () => {
    if (localStorage.getItem("estadosOrdenes") === null) {
      const response =
        await apiInit.GET_INIT_DATA_ESTADOS_ORDENES.getEstadosOrdenes();
      if (response !== null) {
        localStorage.setItem("estadosOrdenes", JSON.stringify(response));
        setEstadosOrdenes(response);
      }
    } else {
      const storage = JSON.parse(
        localStorage.getItem("estadosOrdenes") || "[]",
      );
      setEstadosOrdenes(storage);
    }
  };

  const fetchInitDataAprobadores = async () => {
    const response =
      await apiInit.GET_INIT_DATA_USER_APROBADORES.getAprobadoresSolicitude();
    if (response !== null) {
      localStorage.setItem("aprobadores", JSON.stringify(response));
      setAprobadoresFull(response);
      const arr = JSON.parse(JSON.stringify(response));
      arr.forEach((obj: any) => {
        delete obj.id_usuario;
        delete obj.activo;
        delete obj.dt_cre;
      });
      setAprobadores(arr);
    }
  };

  // --- EL USE EFFECT CORREGIDO ---
  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);
      invalidateCatalogCacheIfOutdated();
      try {
        // Ejecutamos TODAS las promesas en paralelo y esperamos a que terminen
        await Promise.all([
          fetchInitDataItemsForTables(),
          fetchInitDataCentrosForTables(),
          fetchInitDataProveedoresForTables(),
          fetchInitDataTiposSolicitud(),
          fetchInitDataMeses(),
          fetchInitDataEstadosOperacionales(),
          fetchInitDataTiposMoneda(),
          fetchInitDataEstadosSolicitud(),
          fetchInitDataTiposItemsAdq(),
          fetchInitDataEstadosOrdenes(),
          fetchInitDataAprobadores(),
        ]);

        // Solo cuando TODO ha terminado (sea desde API o LocalStorage), quitamos el loading
        if (componentIsMounted.current) {
          setLoading(false);
        }
      } catch (error) {
        console.error("Error cargando datos iniciales", error);
        // Incluso si hay error, quitamos el spinner para no bloquear la UI
        if (componentIsMounted.current) setLoading(false);
      }
    };

    loadAllData();

    return () => {
      componentIsMounted.current = false;
    };
  }, []);

  if (!loading) {
    return (
      <InitDataForTablesContext.Provider
        value={{
          itemsAdquisicion,
          itemsAdquisicionFull,
          centrosCosto,
          centrosCostoFull,
          proveedores,
          tipoSolicitudes,
          meses,
          estadosOperacionales,
          tiposMoneda,
          isTutorialActive,
          setIsTutorialActive,
          estadosSolicitud,
          tiposItemsAdquisicion,
          estadosOrdenes,
          proveedoresFull,
          aprobadores,
          aprobadoresFull,
        }}
      >
        {!loading ? children : null}
      </InitDataForTablesContext.Provider>
    );
  } else {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Icon
          icon={"spinner"}
          className="fa-spin"
          style={{ fontSize: "50px" }}
        />
      </div>
    );
  }
};

function renameKey(obj: { [x: string]: any }, oldKey: string, newKey: string) {
  obj[newKey] = obj[oldKey];
  delete obj[oldKey];
}

export { InitDataForTablesContext, InitDataForTablesProvider };
